import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '950576387884513';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.getElementsByTagName('script')[0]?.parentNode || document.body;
      target?.appendChild(script);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-356">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-357" />
    </noscript>;
}